import {
    Drawer,
    Row,
    Col,
    Card,
    Form,
    Button,
    Input,
    Select,
    Typography,
    Statistic,
    notification
} from "antd";

import React from "react";
import _ from 'lodash';
import Request from "../../request";

const { Option } = Select;
const { Title, Text } = Typography;

@Form.create()
class GenerateBranchInvoiceDrawer extends React.Component {

    state = {
        visible: true,
        studentDetails: [],
        taxDetails: [],
        taxTypeId: null,
        additionalDeduction: null,
        branchInvoiceNumber: null,
        loading: false
    }

    onClose = () => {

        this.setState({ visible: false })
        setTimeout(() => {

            if (this.props.onClose) {
                this.props.onClose();
            }

        }, 200);
    }

    async componentDidMount() {
        this.loadInitialData();
    }

    loadInitialData = async () => {

        let { counsellingData: { usersData } } = this.props;

        let users = [];

        _.each(usersData, (user) => {
            users.push(user.userId);
        });

        let response =
            await Request.getBranchClaimDeskInvoices({
                ids: users
            });

        let taxDetails =
            await Request.getTaxDetails();

        this.setState({
            studentDetails: response.data || [],
            taxDetails: taxDetails.data || []
        });
    }

    // GET TOTAL TAX %

    getTaxPercentage = (taxId) => {

        let { taxDetails } = this.state;

        let found =
            taxDetails.find(item => item._id === taxId);

        let total = 0;

        if (
            found &&
            found.taxTypeArray &&
            found.taxTypeArray.length
        ) {

            _.each(found.taxTypeArray, (item) => {

                // ABS SO THAT -2 OR 2 BOTH WORK

                total += Math.abs(
                    Number(item.taxValue || 0)
                );

            })
        }

        return total;
    }

    generateInvoice = async () => {
        let {
            taxTypeId,
            additionalDeduction,
            branchInvoiceNumber
        } = this.state;
        let { counsellingData: { usersData } } = this.props;
        let users = [];

        _.each(usersData, (user) => {
            users.push(user.userId);
        });
        this.setState({ loading: true });
        let response = await Request.generateBranchClaimInvoice({ taxTypeId, additionalDeduction, branchInvoiceNumber, ids: users });
        this.setState({ loading: false });
        if (response.success) {
            notification.success({
                message: response.message
            })
        } else {
            notification.error({
                message: response.message
            })
        }
        this.onClose();
    }

    render() {

        let {
            visible,
            studentDetails,
            taxDetails,
            taxTypeId,
            additionalDeduction,
            branchInvoiceNumber,
            loading
        } = this.state;

        // SELECTED GST

        let selectedTax =
            taxDetails.find(item => item._id === taxTypeId);

        // SELECTED TDS

        let selectedAdditionalDeduction =
            taxDetails.find(item => item._id === additionalDeduction);

        // GST %

        let gstPercentage =
            this.getTaxPercentage(taxTypeId);

        // TDS %

        let deductionPercentage =
            this.getTaxPercentage(additionalDeduction);

        // TOTALS

        let totalBeforeTax = 0;
        let totalGST = 0;
        let totalAmountInclGST = 0;
        let totalDeduction = 0;
        let totalNetPayable = 0;

        // STYLES

        const tdStyle = {
            padding: 14,
            border: '1px solid #f0f0f0',
            fontSize: 13,
            verticalAlign: 'middle'
        };

        const thStyle = {
            padding: 14,
            border: '1px solid #f0f0f0',
            background: '#fafafa',
            fontWeight: 600,
            whiteSpace: 'nowrap',
            fontSize: 13
        };

        return (

            <Drawer
                title={
                    <Title
                        level={4}
                        style={{ marginBottom: 0 }}
                    >
                        Generate Invoice
                    </Title>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={1000}
                visible={this.state.visible}
            >

                {/* FILTERS */}

                <Card
                    bordered={false}
                    style={{
                        borderRadius: 12,
                        marginBottom: 20,
                        boxShadow: '0 2px 10px rgba(0,0,0,0.06)'
                    }}
                >

                    <Row gutter={20}>

                        {/* INVOICE */}

                        {/* <Col span={8}>

                            <Text strong>
                                Invoice Number
                            </Text>

                            <Input
                                size="large"
                                placeholder="Enter Invoice Number"
                                value={branchInvoiceNumber}
                                style={{ marginTop: 8 }}
                                onChange={(e) => {
                                    this.setState({
                                        branchInvoiceNumber:
                                            e.target.value
                                    })
                                }}
                            />

                        </Col> */}

                        {/* GST */}

                        <Col span={8}>

                            <Text strong>
                                Tax
                            </Text>

                            <Select
                                size="large"
                                placeholder="Select GST"
                                style={{
                                    width: '100%',
                                    marginTop: 8
                                }}
                                value={taxTypeId}
                                onChange={(value) => {
                                    this.setState({
                                        taxTypeId: value
                                    })
                                }}
                            >

                                {
                                    taxDetails.map((item) => {

                                        return (
                                            <Option
                                                key={item._id}
                                                value={item._id}
                                            >
                                                {item.taxTitle}
                                            </Option>
                                        )
                                    })
                                }

                            </Select>

                        </Col>

                        {/* TDS */}

                        <Col span={8}>

                            <Text strong>
                                Additional Deduction
                            </Text>

                            <Select
                                size="large"
                                placeholder="Select Additional Deduction"
                                style={{
                                    width: '100%',
                                    marginTop: 8
                                }}
                                allowClear
                                value={additionalDeduction}
                                onChange={(value) => {
                                    this.setState({
                                        additionalDeduction: value
                                    })
                                }}
                            >

                                {
                                    taxDetails.map((item) => {

                                        return (
                                            <Option
                                                key={item._id}
                                                value={item._id}
                                            >
                                                {item.taxTitle}
                                            </Option>
                                        )
                                    })
                                }

                            </Select>

                        </Col>

                    </Row>

                </Card>

                {/* TABLE */}

                <Card
                    bordered={false}
                    bodyStyle={{ padding: 0 }}
                    style={{
                        borderRadius: 12,
                        overflow: 'hidden',
                        boxShadow: '0 2px 10px rgba(0,0,0,0.06)'
                    }}
                >

                    <div
                        style={{
                            overflowX: 'auto'
                        }}
                    >

                        <table
                            style={{
                                width: '100%',
                                minWidth: 1700,
                                borderCollapse: 'collapse'
                            }}
                        >

                            <thead>

                                <tr>

                                    {
                                        [
                                            'Sr. No',
                                            'Student Name',
                                            'Passport No',
                                            'Student ID',
                                            'University',
                                            'Course',
                                            'Currency',
                                            'Commission',
                                            'Conversion Rate',
                                            'Bank Charges',
                                            'Gross Amount',
                                            'Sharing Rate',
                                            'Amount Before Tax',

                                            selectedTax
                                                ? selectedTax.taxTitle
                                                : 'GST Amount',

                                            'Amount Incl GST',

                                            ...(selectedAdditionalDeduction
                                                ? [selectedAdditionalDeduction.taxTitle]
                                                : []),

                                            'Net Payable'

                                        ].map((item, index) => (

                                            <th
                                                key={index}
                                                style={thStyle}
                                            >
                                                {item}
                                            </th>

                                        ))
                                    }

                                </tr>

                            </thead>

                            <tbody>

                                {
                                    studentDetails &&
                                        studentDetails.length

                                        ?

                                        studentDetails.map((student, index) => {

                                            // GST INCLUDED AMOUNT

                                            let amountInclGST =
                                                Number(student.associateAmount || 0);

                                            // REMOVE GST

                                            let amountBeforeTax =
                                                gstPercentage
                                                    ?
                                                    (
                                                        amountInclGST /
                                                        (
                                                            1 +
                                                            (gstPercentage / 100)
                                                        )
                                                    )
                                                    :
                                                    amountInclGST;

                                            // GST AMOUNT

                                            let gstAmount =
                                                amountInclGST -
                                                amountBeforeTax;

                                            // TDS / DEDUCTION

                                            let deductionAmount = 0;

                                            if (deductionPercentage) {

                                                deductionAmount =
                                                    (
                                                        amountBeforeTax *
                                                        deductionPercentage
                                                    ) / 100;
                                            }

                                            // NET PAYABLE

                                            let netPayable =
                                                amountInclGST -
                                                deductionAmount;

                                            // TOTALS

                                            totalBeforeTax += amountBeforeTax;

                                            totalGST += gstAmount;

                                            totalAmountInclGST += amountInclGST;

                                            totalDeduction += deductionAmount;

                                            totalNetPayable += netPayable;

                                            return (

                                                <tr
                                                    key={index}
                                                    style={{
                                                        background:
                                                            index % 2 === 0
                                                                ? '#fff'
                                                                : '#fafcff'
                                                    }}
                                                >

                                                    {/* SR */}

                                                    <td style={tdStyle}>
                                                        {index + 1}
                                                    </td>

                                                    {/* NAME */}

                                                    <td style={tdStyle}>
                                                        <b>
                                                            {student.studentName || 'NA'}
                                                        </b>
                                                    </td>

                                                    {/* PASSPORT */}

                                                    <td style={tdStyle}>
                                                        {student.passportNumber || 'NA'}
                                                    </td>

                                                    {/* STUDENT ID */}

                                                    <td style={tdStyle}>
                                                        {student.instituteStudentId || 'NA'}
                                                    </td>

                                                    {/* UNIVERSITY */}

                                                    <td style={tdStyle}>
                                                        {student.universityInstitutionName || 'NA'}
                                                    </td>

                                                    {/* COURSE */}

                                                    <td style={tdStyle}>
                                                        {student.courseName || 'NA'}
                                                    </td>

                                                    {/* CURRENCY */}

                                                    <td style={tdStyle}>
                                                        {student.currency || 'NA'}
                                                    </td>

                                                    {/* COMMISSION */}

                                                    <td style={tdStyle}>
                                                        {student.commissionTotal || 0}
                                                    </td>

                                                    {/* CONVERSION */}

                                                    <td style={tdStyle}>
                                                        {student.conversionRate || 0}
                                                    </td>
                                                    <td style={tdStyle}>
                                                        {student.bankCharges || 0}
                                                    </td>

                                                    {/* GROSS */}

                                                    <td style={tdStyle}>
                                                        {student.grossPaymentReceived || 0}
                                                    </td>

                                                    {/* SHARING */}

                                                    <td style={tdStyle}>
                                                        {student.sharingRate || 0}
                                                    </td>

                                                    {/* BEFORE TAX */}

                                                    <td
                                                        style={{
                                                            ...tdStyle,
                                                            fontWeight: 600
                                                        }}
                                                    >
                                                        {amountBeforeTax.toFixed(2)}
                                                    </td>

                                                    {/* GST */}

                                                    <td style={tdStyle}>
                                                        {gstAmount.toFixed(2)}
                                                    </td>

                                                    {/* AMOUNT INCL GST */}

                                                    <td
                                                        style={{
                                                            ...tdStyle,
                                                            fontWeight: 700
                                                        }}
                                                    >
                                                        {amountInclGST.toFixed(2)}
                                                    </td>

                                                    {/* TDS */}

                                                    {
                                                        selectedAdditionalDeduction &&
                                                        <td
                                                            style={{
                                                                ...tdStyle,
                                                                color: '#ff4d4f',
                                                                fontWeight: 600
                                                            }}
                                                        >
                                                            - {deductionAmount.toFixed(2)}
                                                        </td>
                                                    }

                                                    {/* NET PAYABLE */}

                                                    <td
                                                        style={{
                                                            ...tdStyle,
                                                            fontWeight: 700,
                                                            color: '#1890ff'
                                                        }}
                                                    >
                                                        {netPayable.toFixed(2)}
                                                    </td>

                                                </tr>

                                            )

                                        })

                                        :

                                        <tr>

                                            <td
                                                colSpan={16}
                                                style={{
                                                    textAlign: 'center',
                                                    padding: 30
                                                }}
                                            >
                                                No Data Found
                                            </td>

                                        </tr>
                                }

                                {/* TOTAL ROW */}

                                {
                                    studentDetails &&
                                        studentDetails.length

                                        ?

                                        <tr
                                            style={{
                                                background: '#f5f7fa',
                                                fontWeight: 700
                                            }}
                                        >

                                            <td
                                                colSpan={12}
                                                style={{
                                                    ...tdStyle,
                                                    textAlign: 'right'
                                                }}
                                            >
                                                TOTAL
                                            </td>

                                            {/* BEFORE TAX */}

                                            <td style={tdStyle}>
                                                {totalBeforeTax.toFixed(2)}
                                            </td>

                                            {/* GST */}

                                            <td style={tdStyle}>
                                                {totalGST.toFixed(2)}
                                            </td>

                                            {/* AMOUNT INCL GST */}

                                            <td style={tdStyle}>
                                                {totalAmountInclGST.toFixed(2)}
                                            </td>

                                            {/* TDS */}

                                            {
                                                selectedAdditionalDeduction &&
                                                <td
                                                    style={{
                                                        ...tdStyle,
                                                        color: '#ff4d4f',
                                                        fontWeight: 700
                                                    }}
                                                >
                                                    - {totalDeduction.toFixed(2)}
                                                </td>
                                            }

                                            {/* NET */}

                                            <td
                                                style={{
                                                    ...tdStyle,
                                                    color: '#1890ff',
                                                    fontWeight: 700
                                                }}
                                            >
                                                {totalNetPayable.toFixed(2)}
                                            </td>

                                        </tr>

                                        : null
                                }

                            </tbody>

                        </table>

                    </div>

                </Card>

                {/* SUMMARY */}

                <Row
                    gutter={16}
                    style={{
                        marginTop: 20
                    }}
                >

                    <Col span={6}>

                        <Card
                            bordered={false}
                            style={{
                                borderRadius: 12
                            }}
                        >

                            <Statistic
                                title="Amount Before Tax"
                                value={totalBeforeTax}
                                precision={2}
                            />

                        </Card>

                    </Col>

                    <Col span={6}>

                        <Card
                            bordered={false}
                            style={{
                                borderRadius: 12
                            }}
                        >

                            <Statistic
                                title="GST Amount"
                                value={totalGST}
                                precision={2}
                            />

                        </Card>

                    </Col>

                    <Col span={6}>

                        <Card
                            bordered={false}
                            style={{
                                borderRadius: 12
                            }}
                        >

                            <Statistic
                                title={
                                    selectedAdditionalDeduction
                                        ? selectedAdditionalDeduction.taxTitle
                                        : 'Total Deduction'
                                }
                                value={-totalDeduction}
                                precision={2}
                            />

                        </Card>

                    </Col>

                    <Col span={6}>

                        <Card
                            bordered={false}
                            style={{
                                borderRadius: 12,
                                background: '#fafcff'
                            }}
                        >

                            <Statistic
                                title="Net Payable"
                                value={totalNetPayable}
                                precision={2}
                            />

                        </Card>

                    </Col>

                </Row>

                {/* FOOTER */}

                <Card>
                    <Row
                        justify="end"
                        gutter={12}
                        style={{
                            marginTop: 24
                        }}
                    >

                        <Col span={2}>

                            <Button
                                size="large"
                                onClick={this.onClose}
                            >
                                Cancel
                            </Button>

                        </Col>

                        <Col span={4}>

                            <Button
                                type="primary"
                                size="large"
                                loading={loading}
                                onClick={this.generateInvoice}
                            >
                                Generate Invoice
                            </Button>

                        </Col>

                    </Row>
                </Card>

            </Drawer>
        )
    }
}

export default GenerateBranchInvoiceDrawer;